import { Button, Modal } from "antd";
import React, { useCallback } from "react";
import "../LoginScreen/MadalRegister.css";
import { useHistory } from "react-router";

type Props = {
  open: boolean;
  closeDialog: () => void;
  onOk: () => void;
};
const ModalRegister: React.FC<Props> = ({ open, onOk, closeDialog }) => {
  const history = useHistory();
  const onClickLegalEntity = useCallback(() => {
    closeDialog();
    history.push("/register-legalEntity");
  }, []);
  const onClickIndividual = useCallback(() => {
    closeDialog();
    history.push("/register-individual");
  }, []);
  return (
    <Modal
      className="custom-modal"
      visible={open}
      onCancel={closeDialog}
      width={600}
      centered
      footer={null}
      bodyStyle={{ backgroundColor: 'transparent', padding: 0 }}
      style={{ backgroundColor: 'transparent', backdropFilter: 'blur(10px)' }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
          height: "350px",
          borderRadius: '8px',
          backgroundColor: 'rgba(255, 255, 255, 0.3)'
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: "2.5rem",
            textAlign: "center",
            width: "80%",
          }}
        >
          เลือกประเภทผู้ประกอบการ
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              marginTop: "2rem",
            }}
          >
            <Button
              className="custom-button3"
              style={{
                backgroundColor: "#C95559",
                color: "#F0F0F0",
                borderRadius: "8px",
                height: "60px",
                fontSize: "2rem",
                fontWeight: "bold",
                border: 'none',
              }}
              onClick={onClickLegalEntity}
            >
              นิติบุคคล
            </Button>
            <Button
              className="custom-button3"
              style={{
                backgroundColor: "#C95559",
                color: "#F0F0F0",
                borderRadius: "8px",
                height: "60px",
                fontSize: "2rem",
                fontWeight: "bold",
                border: 'none',
              }}
              onClick={onClickIndividual}
            >
              บุคคลธรรมดา
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalRegister;
